import styled from 'styled-components'

export const ColoredMap = styled.div`
  width: 100%;
`
